function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.227 14.62c1.123 3.415 0 3.38 0 3.38s-6.182 2-9.274 2c-3.189 0-9.566-2-9.566-2s-.87-1.34 0-3.38 2.15-4.108 4.568-3.543c1.703 1.227 3.54 3.651 4.852 3.651 1.558 0 3.925-2.724 5.896-3.65 1.957-.92 2.401.127 3.524 3.542zM9.863 0c2.476 0 4.483 2.409 4.483 5.38s-2.007 5.38-4.483 5.38c-2.476 0-4.483-2.409-4.483-5.38S7.387 0 9.863 0z",
  fill: "#0C2C52",
  fillRule: "evenodd"
});

function SvgIconEmployee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmployee);
export default __webpack_public_path__ + "static/media/icon-employee.f7756d45.svg";
export { ForwardRef as ReactComponent };